import { createContext, useReducer } from 'react'
import investorReducer from './InvestorReducer'
import InvestorType from './InvestorType'
import {
  getInvestors,
  getInvestor,
  creditChargeManual,
  updateInvestor,
  getRequestInvest,
  getRequestInvestByStartupId,
  changeRequestInvest,
  getInvoicesByAdmin,
  confirmReceipt,
  rejectReceipt,
  getRequestInvestByInvestorId,
  getReceiptInvoices,
  creditRejectReceipt,
} from './InvestorActions'

const InvestorContext = createContext()

export const InvestorProvider = ({ children }) => {
  const initialState = {
    investors: [],
    investor: {},
    requests: [],
    request: {},
    ticket: {},
    invoices: [],
    admins: [],
    loading: false,
  }

  const [state, dispatch] = useReducer(investorReducer, initialState)

  const fetchInvestors = async (params) => {
    try {
      dispatch({ type: 'SET_LOADING' })
      const investorsData = await getInvestors(params)
      dispatch({
        type: InvestorType.GET_INVESTORS,
        payload: investorsData,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const fetchInvestor = async (id) => {
    try {
      dispatch({ type: 'SET_LOADING' })
      const investorData = await getInvestor(id)
      dispatch({
        type: InvestorType.GET_INVESTOR,
        payload: investorData,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const creditCharge = async (values) => {
    try {
      dispatch({ type: 'SET_LOADING' })
      const creditData = await creditChargeManual(values)
      dispatch({
        type: InvestorType.CREDIT_CHARGE_MANUAL,
        payload: creditData,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const creditReject = async (values) => {
    try {
      dispatch({ type: 'SET_LOADING' })
      const creditData = await creditRejectReceipt(values)
      dispatch({
        type: InvestorType.CREDIT_REJECT_RECEIPT,
        payload: creditData,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const editInvestor = async (id, investor) => {
    try {
      const investorData = await updateInvestor(id, investor)
      dispatch({ type: InvestorType.UPDATE_INVESTOR, payload: investorData })
    } catch (error) {
      console.log(error)
    }
  }

  const fetchRequestInvest = async () => {
    try {
      dispatch({ type: 'SET_LOADING' })
      const requestInvestData = await getRequestInvest()
      dispatch({
        type: InvestorType.GET_REQUEST_INVEST,
        payload: requestInvestData,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const fetchRequestInvestByStartupId = async (startupId) => {
    try {
      const requestInvestData = await getRequestInvestByStartupId(startupId)
      dispatch({
        type: InvestorType.GET_REQUEST_INVEST_BY_STARTUP_ID,
        payload: requestInvestData,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const fetchRequestInvestByInvestorId = async (investorId) => {
    try {
      const requestInvestData = await getRequestInvestByInvestorId(investorId)
      dispatch({
        type: InvestorType.GET_REQUEST_INVEST_BY_STARTUP_ID,
        payload: requestInvestData,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const handleChangeRequestInvest = async (requestId, data) => {
    try {
      const requestInvestData = await changeRequestInvest(requestId, data)
      dispatch({
        type: InvestorType.CHANGE_REQUEST_INVEST,
        payload: requestInvestData,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const fetchInvoicesByAdmin = async (params) => {
    try {
      const invoicesData = await getInvoicesByAdmin(params)
      dispatch({
        type: InvestorType.GET_INVOICES_BY_ADMIN,
        payload: invoicesData,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const handleConfirmInvoice = async (invoiceId) => {
    try {
      const invoiceData = await confirmReceipt(invoiceId)
      dispatch({
        type: InvestorType.CONFIRM_RECEIPT,
        payload: invoiceData,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const handleRejectInvoice = async (invoiceId) => {
    try {
      const invoiceData = await rejectReceipt(invoiceId)
      dispatch({
        type: InvestorType.REJECT_RECEIPT,
        payload: invoiceData,
      })
      fetchInvoicesByAdmin({
        typeOfInvoice: 'RECEIPT',
      })
    } catch (error) {
      console.log(error)
    }
  }

  const fetchReceiptInvoices = async (investorId) => {
    try {
      dispatch({ type: 'SET_LOADING' })
      const invoicesData = await getReceiptInvoices(investorId)
      dispatch({
        type: InvestorType.GET_RECEIPT_INVOICES,
        payload: invoicesData,
      })
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <InvestorContext.Provider
      value={{
        ...state,
        dispatch,
        fetchInvestors,
        fetchInvestor,
        creditCharge,
        editInvestor,
        fetchRequestInvest,
        fetchRequestInvestByStartupId,
        handleChangeRequestInvest,
        fetchInvoicesByAdmin,
        handleConfirmInvoice,
        handleRejectInvoice,
        fetchRequestInvestByInvestorId,
        fetchReceiptInvoices,
        creditReject,
      }}
    >
      {children}
    </InvestorContext.Provider>
  )
}

export default InvestorContext
